var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"utility bg-tertiary",class:{ 'utility--active': _vm.isActive }},[_c('div',{staticClass:"bg-tertiary"},[_vm._t("default")],2),_c('div',{staticClass:"utility__overlay"})])
}
var staticRenderFns = []

export { render, staticRenderFns }